// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"SearchBar_searchBarContainer__Wn+dP","searchIcon":"SearchBar_searchIcon__43rYG","dropdown":"SearchBar_dropdown__+0Qvl"};